export enum UserViewMode {
  View = 'view',
  ViewAccess = 'viewAccess',
  EditAccess = 'editAccess',
}

export enum UsersViewMode {
  All = 'all',
  FullAdmins = 'fullAdmins',
  Users = 'users',
  Unassigned = 'unassigned',
}
